// extracted by mini-css-extract-plugin
export default {"container":"zoom_container__3kDb1","icon":"zoom_icon__RdGF7","plus":"zoom_plus__WLSsQ zoom_icon__RdGF7","minus":"zoom_minus__l7pLy zoom_icon__RdGF7"};